export default __webpack_public_path__ + "static/logsign-1d49b27d74bc1d99d4a6684456e304f9.jpg";